// extracted by mini-css-extract-plugin
module.exports = {"grid":"AppFooter_grid__18OcS","appFooter":"AppFooter_appFooter__BG_VJ","spanContainer":"AppFooter_spanContainer__kwNff","mainSpan":"AppFooter_mainSpan__3DZfW"};